export default __webpack_public_path__ + "static/media/pepe-goes-to-war.d6b36b1b.jpeg";